import { gql } from '@apollo/client';
import { DealItemFragment } from './DealItemFragment';
import { DealClientFragment } from './DealClientFragment';
import { DealContactFragment } from './DealContactFragment';
import { CurrencyFragment } from 'graphql/Currency/fragments/CurrencyFragment';
import { LocationFragment } from 'graphql/Location/fragments/LocationFragment';
import { DealOtherFeeFragment } from './DealOtherFeeFragment';
import { DealTaxFragment } from './DealTaxFragment';
import { ConfigurationFieldFragment } from 'graphql/ConfigurationField/fragments/ConfigurationFieldFragment';
import { FieldValueFragment } from 'graphql/FieldValue/fragments/FieldValueFragment';
/**
 * @fragment DealFragment
 * @since 1.0.0
 */
export const DealFragment = gql `
  fragment DealFragment on Deal {
    id

    date
    title
    headline
    introduction
    termsAndConditions
    type
    number
    draft
    directSale
    status
    stage
    notes
    showIncludedOptions
    subtotal
    taxAmount
    total
    currency {
      code
    }
    discount
    discountType
    promoCode {
      code
      type
      value
      discountAmount
      status
    }
    language
    validityPeriod
    priceDisplay
    canGeneratePDF
    canEditQuantity
    canBeSigned
    showDiscount
    createdAt
    updatedAt
    orderIn
    plannedDateStart
    plannedDateEnd

    fieldValues {
      ...FieldValueFragment
    }

    user {
      id
      firstname
      lastname
      email
      fullname
      title
      account {
        id
        name
        tag
        href
        website
        civicNumber
        road
        city
        province
        country
        postalcode
        logo {
          url
        }
        icon {
          url
        }
      }
      contact {
        id
        title
        client {
          name

          primaryLocation {
            ...LocationFragment
          }

          image {
            url
          }
        }
      }
      image {
        url
      }
    }

    partner {
      id
      name

      primaryLocation {
        ...LocationFragment
      }

      image {
        ...MediaFragment
      }
    }

    partnerContact {
      ...DealContactFragment
    }

    client {
      ...DealClientFragment
    }

    contact {
      ...DealContactFragment
    }

    billTo {
      ...LocationFragment
    }

    shipTo {
      ...LocationFragment
    }

    currency {
      ...CurrencyFragment
    }

    term {
      id
      title
      infos
      file {
        id
        url
      }
    }

    accountTerm {
      id
      title
      infos
      file {
        id
        url
      }
    }

    items {
      ...DealItemFragment
    }

    otherFees {
      ...DealOtherFeeFragment
    }

    taxes {
      ...DealTaxFragment
    }

    approbations {
      state
      firstName
      lastName
      email
      date
      signatureBase64
      createdAt
      user {
        id
        fullname
      }
    }

    configurationFields {
      ...ConfigurationFieldFragment
    }

    translations {
      headline
      introduction
      termsAndConditions
      language {
        id
        name
        code
      }
    }

    messages {
      id
      message
      createdAt
      user {
        id
        fullname
        firstname
        lastname
      }
    }

    medias {
      id
      type
      media {
        id
        url
      }
      url
    }

    payments {
      id
      date
      description
      status
      amount
      percent
      isDeposit
    }

    paymentIntegration {
      type
      key
      accountId
      enterpriseId
      checkoutBaseUrl
    }
  }

  ${FieldValueFragment}
  ${DealClientFragment}
  ${DealContactFragment}
  ${LocationFragment}
  ${CurrencyFragment}
  ${DealItemFragment}
  ${DealOtherFeeFragment}
  ${DealTaxFragment}
  ${ConfigurationFieldFragment}
`;
